export const REQ_RETREADBRANDS_SUCCESS = "REQ_RETREADBRANDS_SUCCESS"
export const REQ_RETREADBRANDS_MIN_SUCCESS = "REQ_RETREADBRANDS_MIN_SUCCESS"